import { ThemeConfig, ThemeName } from "@/types/theme";

export const themes: Record<ThemeName, ThemeConfig> = {
  default: {
    name: "default",
    colors: {
      /** Brand base / CTAs (Figma: brand-base #d60b52) */
      primary: "#D60B52",
      secondary: "#D60B52",
      /** Dark Base/05 — rodapés e superfícies escuras secundárias */
      tertiary: "#363636",
      primaryLight: "#F8F8F9",
      /** Superfície de página (Grayscale/Gray 100) */
      background: "#F8F8F9",
      /** Campos e painéis claros sobre fundo escuro */
      foreground: "#FFFFFF",
      /** Texto principal sobre superfície clara (brand complement) */
      text: "#0E0D0D",
      textSecondary: "#909090",
      border: "#E8E8E8",
      error: "#ef4444",
      success: "#10b981",
      successMuted: "#e5f9f2",
      successMutedText: "#00764c",
      info: "#1e40af",
      infoMuted: "#eaf0fe",
      infoMutedText: "#355da5",
      errorMuted: "#fde8ee",
      errorMutedText: "#c41e3a",
      warningMuted: "#fbf6e9",
      warningMutedText: "#363636",
      disabled: "#D1D5DB",
      disabledText: "#9CA3AF",
    },
    fonts: {
      primary: "Hanken, sans-serif",
      secondary: "Ubuntu, sans-serif",
    },
    spacing: {
      base: "0.25rem", // 4px
      small: "0.5rem", // 8px
      medium: "1rem", // 16px
      large: "1.5rem", // 24px
      xlarge: "2rem", // 32px
    },
    borderRadius: {
      small: "0.5rem", // 8px — alinhado a cantos menores (ex.: captcha)
      medium: "0.625rem", // 10px — inputs / CTA mobile Figma
      large: "0.75rem", // 12px
      xlarge: "1.25rem", // 20px — card de formulário
    },
  },
  zapay: {
    name: "zapay",
    colors: {
      primary: "#FF0060",
      primaryLight: "#ffe6f0",
      secondary: "#ff4d8a",
      tertiary: "#666666",
      background: "#FFF",
      foreground: "#F0F0F0",
      text: "#000000",
      textSecondary: "#666666",
      border: "#e0e0e0",
      error: "#ff3333",
      success: "#00d4aa",
      successMuted: "#e5f9f2",
      successMutedText: "#00764c",
      info: "#1e40af",
      infoMuted: "#eaf0fe",
      infoMutedText: "#355da5",
      errorMuted: "#fde8ee",
      errorMutedText: "#c41e3a",
      warningMuted: "#fbf6e9",
      warningMutedText: "#363636",
      disabled: "#d1d5db",
      disabledText: "#6b7280",
    },
    fonts: {
      primary: "Inter, sans-serif",
      secondary: "Inter, sans-serif",
    },
    spacing: {
      base: "0.25rem",
      small: "0.5rem",
      medium: "1rem",
      large: "1.75rem", // 28px
      xlarge: "2.5rem", // 40px
    },
    borderRadius: {
      small: "0.5rem", // 8px
      medium: "2rem", // 16px
      large: "1.5rem", // 24px
      xlarge: "2rem", // 32px
    },
  },
};

export const getTheme = (themeName: ThemeName): ThemeConfig => {
  return themes[themeName] || themes.default;
};
